import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { WindowBlindsId } from '@core/constants/Shape';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { WindowBlindsOptionsId } from '@core/constants/Option';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    allFabric,
    allMetals,
    allPlastics,
    allWoods,
    getMaterialsWithExceptions,
} from './common/materialGroups';

const windowBlindsIndoorForm: IForm = {
    formId       : PublishedFormId.CustomBlind,
    type         : FormTypeId.Blinds,
    thumbnailURL : '/resized-images/forms/windowBlindsIndoor.png',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.WindowBlindsStyle,
        IFormFieldKey.WindowBlindsDimension,
        IFormFieldKey.WindowBlindsFilling,
        IFormFieldKey.WindowBlindsFunction,
        IFormFieldKey.WindowBlindsGlassDimension,
        IFormFieldKey.Material,
        IFormFieldKey.WindowBlindsElectric,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        windowBlindsStyle: {
            value   : undefined,
            options : [
                WindowBlindsId.WindowBlindsBoat,
                WindowBlindsId.WindowBlindsCalifornian,
                WindowBlindsId.WindowBlindsJapanese,
                WindowBlindsId.WindowBlindsPleated,
                WindowBlindsId.WindowBlindsVelux,
                WindowBlindsId.WindowBlindsVenetian,
                WindowBlindsId.WindowBlindsWinder,
            ],
            required: true,
        },
        windowBlindsDimension: {
            [FieldDimensionId.Width]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 200, max: 4000 },
                required     : true,
                defaultValue : 1000,
            },
            [FieldDimensionId.Height]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 500, max: 3500 },
                required     : true,
                defaultValue : 1500,
            },
        },
        windowBlindsFilling: {
            value   : undefined,
            options : [
                WindowBlindsOptionsId.FillingUniform,
                WindowBlindsOptionsId.FillingOpenwork,
            ],
            required: true,
        },
        windowBlindsFunction: {
            value   : undefined,
            options : [
                WindowBlindsId.WindowBlindsBlackout,
                WindowBlindsId.WindowBlindsDayNight,
                WindowBlindsId.WindowBlindsSifting,
            ],
            required: true,
        },
        windowBlindsGlassDimension: {
            [FieldDimensionId.Width]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 200, max: 4000 },
                required     : true,
                defaultValue : 1000,
            },
            [FieldDimensionId.Height]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 500, max: 3500 },
                required     : true,
                defaultValue : 1500,
            },
        },
        material: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions([
                    ...allMetals,
                    ...allPlastics,
                    ...allWoods,
                    ...allFabric,
                ],
                [
                    MaterialId.Steel,
                    MaterialId.Rust,
                    MaterialId.Brass,
                    MaterialId.Iron,
                    MaterialId.ThermoLaqueredBlack,
                    MaterialId.ThermoLaqueredWhite,
                    MaterialId.SheetMetal,
                    MaterialId.StainlessSteel,
                    MaterialId.Zinc,
                    MaterialId.WroughtIron,
                    MaterialId.BlackLocust,
                    MaterialId.Iroko,
                    MaterialId.Douglas,
                    MaterialId.DouglasEngineered,
                    MaterialId.DouglasRecycled,
                    MaterialId.DouglasVeneer,
                    MaterialId.Garapa,
                    MaterialId.PlexiglassFluorescent,
                    MaterialId.PlexiglassFrosted,
                    MaterialId.PlexiglassMirror,
                    MaterialId.PlexiglassTransparent,
                    MaterialId.PlexiglassWhite,
                    MaterialId.PolycarbonateOpaque,
                    MaterialId.PolycarbonateTeinted,
                    MaterialId.PolycarbonateTransparent,
                    MaterialId.RecycledPlastic,
                    MaterialId.FabricAcrylic,
                    MaterialId.FabricMicroPerforated,
                    MaterialId.FabricPolyester,
                ]),
                required: true,
            },
        },
        windowBlindsElectric: {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 5000,
            budgetDefaultValue : 1500,
        }),
        contact: fieldsContact,
    },
};

export default windowBlindsIndoorForm;
